var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming-soon-container"},[_c('h1',[_vm._v("coming soon"),_c('span',{staticClass:"dot"},[_vm._v(".")])]),_c('p',[_vm._v("Exciting sponsorship opportunities will be available here soon. We're working to create valuable partnerships — stay connected.")])])
}]

export { render, staticRenderFns }